import { type ExamCourseSettings } from '@exam-center/graphql';
import {
  Flex,
  InfoOutlinedIcon,
  type OptionSelectionProps,
  Text,
  Tooltip,
} from '@shared/components';
import type { TableHeaderRow } from '@shared/table-generator';
import { formatSecondsToHoursMinutes } from '@shared/utils';

import { getCellBaseStyle } from '../base-monthly-exam-distribution-table/utils';

function renderHeaderWithTooltip(
  courseCodeSettings: Partial<Pick<ExamCourseSettings, 'examDuration'>>,
) {
  return (
    <Flex sx={{ flexDirection: 'column', gap: 1 }}>
      ระยะเวลาสอบ <br />
      {courseCodeSettings.examDuration?.sessions.length
        ? courseCodeSettings.examDuration.sessions.map((session, index) => {
            return (
              <>
                {index > 0 ? <br /> : null}
                ช่วงที่ {session.order}: {formatSecondsToHoursMinutes(session.value, 'TEXT')}
              </>
            );
          })
        : 'ไม่ระบุระยะเวลาสอบ'}
    </Flex>
  );
}

export function getColumns(
  examEventCourses: readonly {
    examCourse: {
      code: string;
      examId: number;
      settings: Partial<Pick<ExamCourseSettings, 'examDuration'>>;
    };
    options: readonly OptionSelectionProps[];
  }[],
) {
  const coursesLength = examEventCourses.length;

  return [
    {
      children: [
        {
          id: 'exam-distribution-table-courses',
          children: 'หลักสูตรที่เปิดสอบ',
          align: 'center',
          rowSpan: 1,
          colSpan: coursesLength,
          sx: {
            width: '100%',
          },
        },
      ],
    },
    {
      children: examEventCourses.map((course) => {
        return {
          children: (
            <Flex
              sx={(theme) => ({
                gap: theme.spacing(1),
                justifyContent: 'center',
                alignItems: 'center',
                minWidth: '140px',
              })}
            >
              <Text variant='body1Semibold'>{course.examCourse.code}</Text>
              <Tooltip title={renderHeaderWithTooltip(course.examCourse.settings)} arrow>
                <InfoOutlinedIcon sx={{ fontSize: '20px' }} />
              </Tooltip>
            </Flex>
          ),
          align: 'center',
          sx: getCellBaseStyle('76px'),
        };
      }),
    },
  ] as TableHeaderRow[];
}
